<template>
  <div class="lovedrift-list">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Select v-model="formItem.status" clearable style="width:200px" placeholder="请选择状态...">
              <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="columns1" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 查看的弹出 -->
    <Drawer
      :title="title"
      v-model="showModalStatus"
      width="60"
      :mask-closable="false"
      :styles="styles"
    >
      <Form :model="headline" action="javascript:void(0)">
        <FormItem label="标题">
          <Input v-model="headline.title" placeholder="请输入标题" readonly />
        </FormItem>
        <FormItem label="事件时间">
          <Button type="text">{{headline.push_at}}</Button>
        </FormItem>
        <FormItem label="事件坐标">
          <Button
            type="text"
          >{{(headline.provice_name?headline.provice_name:'')+(headline.city_name?headline.city_name:'')+(headline.area_name?headline.area_name:'')+(headline.landmark?headline.landmark:'')}}</Button>
        </FormItem>
        <FormItem label="事件地址">
          <Button type="text">{{headline.address}}</Button>
        </FormItem>
        <FormItem label="音频" v-if="headline.audio_url">
          <audio :src="headline.audio_url" controls></audio>
        </FormItem>
        <FormItem label="相册">
          <upload-thumb
            v-model="headline.thumb"
            ref="UploadThumb"
            :defaultList="thumblist"
            :autoCropWidth="320"
            :autoCropHeight="415"
            :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:320*415,大小不超过2M'"
          ></upload-thumb>
        </FormItem>
<!--        <FormItem label="内容">-->
<!--          <editor-bar v-model="headline.content" :isClear="isClear" ref="editContent" readonly></editor-bar>-->
<!--        </FormItem>-->
        <FormItem label="内容">
          <UEditor v-model="headline.content"  ref="editContent" readonly></UEditor>
        </FormItem>
        <div class="demo-drawer-footer">
          <Button style="margin-right: 8px" @click="showModalStatus = false">取消</Button>
        </div>
      </Form>
    </Drawer>
    <!-- 审核弹框 -->
    <Form :model="headlinedata" action="javascript:void(0)">
      <Modal
        v-model="showHeadlineStatus"
        title="审核"
        @on-ok="reviewHeadline()"
        :loading="dataloading"
      >
        <FormItem label="审核状态" label-position="top">
          <RadioGroup v-model="headlinedata.status">
            <Radio label="0">待审核</Radio>
            <Radio label="1">通过</Radio>
            <Radio label="2">不通过</Radio>
          </RadioGroup>
        </FormItem>
      </Modal>
    </Form>
    <!-- 审核弹框 end -->
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from '../common/ueditor';

export default {
  name: "lovedrift-list",
  data() {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      title: "",
      isClear: false,
      loading: true,
      dataloading: true,
      formItem: {},
      thumblist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 100,
          fixed: "left"
        },
        {
          title: "标题",
          key: "title",
          fixed: "left"
        },
        {
          title: "发布人",
          key: "admin_name",
          fixed: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.userdata.nickname == ""
                  ? params.row.userdata.username
                  : params.row.userdata.nickname
              )
            ]);
          }
        },
        {
          title: "事件时间",
          key: "push_at",
          fixed: "left",
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.push_at ? params.row.push_at : "")
            ]);
          }
        },
        {
          title: "位置",
          key: "landmark",
          fixed: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                (params.row.provice_name ? params.row.provice_name : "") +
                  (params.row.city_name ? params.row.city_name : "") +
                  (params.row.area_name ? params.row.area_name : "") +
                  (params.row.landmark ? params.row.landmark : "")
              )
            ]);
          }
        },
        {
          title: "音频",
          key: "audio_url",
          width: 150
        },
        {
          title: "审核状态",
          key: "role",
          fixed: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.status == "0"
                  ? "未审核"
                  : params.row.status == "1"
                  ? "审核通过"
                  : "未通过审核"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id);
                    }
                  }
                },
                "审核"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "查看"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginLeft: "5px",
                    display:
                      params.row.status == "1" && params.row.is_history == "0"
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.pushhistory(params.row.id);
                    }
                  }
                },
                "同步历史消息"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      headlinedata: {
        status: "0"
      },
      statusList: [
        { id: 0, name: "未审核" },
        { id: 1, name: "审核通过" },
        { id: 2, name: "未通过审核" }
      ],
      headline: {},
      showModalStatus: false,
      showHeadlineStatus: false
    };
  },
  // 计算
  computed: {},
  components: {
    UploadThumb,
    // EditorBar
    UEditor
  },
  // 监听
  watch: {},
  created: function() {
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      var self = this;
      this.$api.lovedrift
        .list({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            self.tablelist = res.result.list;
            self.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    //展开修改
    showEditInfo: function(index) {
      this.headlineid = index;
      this.headline.audio_url = null;
      this.thumblist = new Array();
      this.showModalStatus = !this.showModalStatus;
      this.$api.lovedrift.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.headline = res.result;
          // this.$refs["editContent"].editor.txt.html(this.headline.content);
          this.$refs['editContent'].message = this.headline.content;
          if (
            this.headline.thumb != "" &&
            this.headline.thumb != null &&
            this.headline.thumb.length > 0
          ) {
            for (var s in this.headline.attrShow) {
              this.thumblist.push({
                name: this.headline.attrShow[s],
                url: this.headline.attrShow[s],
                status: "finished"
              });
            }
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status
      };
      this.$api.lovedrift.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.lovedrift.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    review: function(id) {
      this.headlineid = id;
      this.showHeadlineStatus = !this.showHeadlineStatus;
    },
    // 添加
    reviewHeadline: function(name) {
      this.$api.lovedrift
        .status({ id: this.headlineid, status: this.headlinedata.status })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
          }
        });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    //同步历史消息
    pushhistory: function(id) {
      this.$api.lovedrift.pushhistory({ id: id }).then(res => {
        if (res.code == 200) {
          this.getTableList();
        }
      });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    }
  }
};
</script>
